/* eslint-disable react-hooks/exhaustive-deps */

import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";
import MDButton from "components/MDButton";
import DeleteModal from "components/deletemodal/deletemodal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import { useMaterialUIController } from "context";
import PageTitle from "examples/PageTitle/PageTitle";
import { useDispatch, } from 'react-redux';
import { Link } from "react-router-dom";
import { deleteCustomerRecords, fetchCustom } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";


function Customers() {
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [rows, setRows] = useState([]);
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [deleteHeading, setDeleteHeading] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [values, setValues] = React.useState({
    _id: [],
    sortingType: "",
    sortingField: "",
    customerStatus: "All",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameterList: ['customerType', 'businessName', 'businessID', 'firstName', 'lastName', 'customerStatus', 'customerName'],
    businessUserID: JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))?.businessUserID,
  });
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      await getRight();
      await fetchCustomers();
    })();
  }, [values.customerStatus, values.sortingType, perPage, dispatch]);

  const handleCancel = name => event => {
    setDeleteDialogeFlag(false);
  };
  const handleDeleteDialogeClick = async (_id) => {
    values._id = []
    values._id.push(_id)
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };
  const handleDelete = async (id) => {
    deleteCustomer();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };
  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = page => {
    values.page = page;
    fetchCustomers();
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage
    setPerPage(newPerPage);
  };
  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };
  const contextActions = useMemo(() => {
    const handleDeleteMultiple = () => {
      if (toggleCleared) setSelectedRows([])
      setDeleteDialogeFlag(!deleteDialogeFlag);
      setDeleteHeading("Would you like to delete selected records?");
      if (selectedRows) {
        values._id = []
        for (let element of selectedRows) {
          values._id.push(element._id);
        }
      }
    };
    return (
      <MDButton onClick={handleDeleteMultiple} color="error" >
        Delete
      </MDButton>
    );
  }, [selectedRows, toggleCleared]);
  const handleRowSelected = useCallback(state => {
    setSelectedRows(state.selectedRows);
    if (state.selectedRows.length > 0) {
      setTitle(" ");
    }
    else {
      setTitle("");
      setDeleteHeading("");
    }
  }, []);
  const deleteCustomer = async () => {
    await deleteCustomerRecords(values, (data) => {
      fetchCustomers();
      setToggleCleared(true);
      setTitle("");
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status);
    }, dispatch)
  };

  async function getRight() {
    let right = await getScreenRight("Customers")
    if (right === "Full Access") setDisableColor(false)
    else setDisableColor(true)
  }


  const fetchCustomers = async () => {
    await fetchCustom(values, (data) => {
      setTotalRows(data.Result_Output.totalDocs);
      setRows(data.Result_Output.docs)
    }, dispatch)
  }

  let columns = [
    {
      name: "Customer Name",
      selector: row => row.customerName,
      sortable: true,
      sortField: 'customerName',
    },
    {
      name: "Customer Type",
      selector: row => row.customerType,
      sortable: true,
      sortField: 'customerType',
    },
    {
      name: "Business Name",
      selector: row => row.businessName,
      sortable: true,
      sortField: 'businessName',
    },
    {
      name: "ABN",
      selector: row => row.businessID,
      sortable: true,
      sortField: 'businessID',
    },
    {
      name: "First Name",
      selector: row => row.firstName,
      sortable: true,
      sortField: 'firstName',
    },
    {
      name: "Last Name",
      selector: row => row.lastName,
      sortable: true,
      sortField: 'lastName',
    },
    {
      name: "Customer Status",
      selector: row => row.customerStatus,
      sortable: true,
      sortField: 'customerStatus',
    },
    {
      name: "Actions",
      selector: row => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
            <Grid item>
              <Link
                to={`/customers/editCustomer/edit/${row._id}`}
              >
                <TimelineItem color="success" icon="edit" title="Edit" />
              </Link>
            </Grid>
            <Grid item >
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete"
              />
            </Grid>
          </Grid>

        </>
      ),
    },
  ]
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: '20px' }}>
        <Card color="primary">
          <PageTitle screenName="Customers" />
          <Grid container display={"flex"} justifyContent="end" mt={2} gap={2}>
            <Grid lg={2.5} xs={6} >
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "44.11px" }}
                  label="Filter By Status"
                  value={values.customerStatus}
                  onChange={(e) => setValues({ ...values, customerStatus: e.target.value })}
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <TextField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                InputProps={{
                  endAdornment: (
                    <InputAdornment  >
                      <Button style={{ borderRadius: "0px 0.5rem  0.5rem 0px", boxShadow: "none", background: barColor }} variant="contained" onClick={fetchCustomers}>
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: '16px' }}>
              <Link to={"/customers/addNewCustomer"}>
                <MDButton
                  variant="contained"
                  className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
                  color={disableColor ? "secondary" : "success"}
                >
                  Add New
                </MDButton>
              </Link>
            </div>
          </Grid>
          <CardContent>
            <BTable
              title={title}
              columns={columns}
              data={rows}
              selectableRows
              // onSort={handleSort}
              sortingType={handleSort}
              sortServer
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              contextActions={contextActions}
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={toggleCleared}
              fixedHeaderScrollHeight="410px"
              fixedHeader={true}

            />
          </CardContent>
        </Card>
      </div >
      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
        heading={deleteHeading}
      />
    </DashboardLayout>
  );
}

export default Customers;
